/**
 * WalkAndPunch API
 * This is the WalkAndPunch Service API.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type ConditionType = 0 | 1 | 2;

export const ConditionType = {
    NUMBER_0: 0 as ConditionType,
    NUMBER_1: 1 as ConditionType,
    NUMBER_2: 2 as ConditionType
};